import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import { LIST_SERVER_PAGINATION_INITIAL_STATE, ListServerPaginationStateModel } from '../../../../../../common/models';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../../common';
import { Sc3FailedMessagesModel } from '../../models';
import { Sc3FailedMessagesListInitialState, Sc3FailedMessagesListLoad } from './sc3-failed-messages-list.actions';
import { Sc3FailedMessagesListService } from './sc3-failed-messages-list.service';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export type Sc3FailedMessagesListStateModel = ListServerPaginationStateModel<Sc3FailedMessagesModel>;

const initialState: Sc3FailedMessagesListStateModel = LIST_SERVER_PAGINATION_INITIAL_STATE;

@State<Sc3FailedMessagesListStateModel>({
  name: 'sc3FailedMessagesList',
  defaults: initialState,
})
@Injectable()
export class Sc3FailedMessagesListState {
  constructor(
    private sc3DataQualityListService: Sc3FailedMessagesListService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: Sc3FailedMessagesListStateModel): Sc3FailedMessagesListStateModel {
    return state;
  }

  @Selector()
  static getItems(state: Sc3FailedMessagesListStateModel): Sc3FailedMessagesModel[] {
    return state.items;
  }

  @Selector()
  static getTotalElements(state: Sc3FailedMessagesListStateModel): number {
    return state.totalElements;
  }

  @Selector()
  static getLoaded(state: Sc3FailedMessagesListStateModel): boolean {
    return state.loaded;
  }

  @Action(Sc3FailedMessagesListLoad)
  getPartners(
    ctx: StateContext<Sc3FailedMessagesListStateModel>,
    { payload }: Sc3FailedMessagesListLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.sc3DataQualityListService.getSc3FailedMessagesList(payload).pipe(
      take(1),
      map((items: Sc3FailedMessagesModel[]) => {
        ctx.patchState({ ...items, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(Sc3FailedMessagesListInitialState)
  setInitialState(ctx: StateContext<Sc3FailedMessagesListStateModel>): void {
    ctx.setState(initialState);
  }
}
